import { action, makeObservable, observable } from 'mobx';

type MessagingConnectionState =
  | { status: 'connected' }
  | { disconnectedAt: number; status: 'disconnected' };

const CONNECTED: MessagingConnectionState = { status: 'connected' };

class MessagingConnectionStore {
  connection: MessagingConnectionState = CONNECTED;

  constructor() {
    makeObservable(this, {
      connection: observable.ref,
      markConnected: action,
      markDisconnected: action,
    });
  }

  markConnected() {
    if (this.connection.status === 'connected') return;

    this.connection = CONNECTED;
  }

  /** Keeps the first drop's time, so a run of failed reconnect attempts does not restart the clock. */
  markDisconnected() {
    if (this.connection.status === 'disconnected') return;

    this.connection = { disconnectedAt: Date.now(), status: 'disconnected' };
  }
}

export default MessagingConnectionStore;
